export function isTopbarVisible(): boolean {
  return document.body.classList.contains('topbar-visible');
}
